/* MD free gift with purchase: auto-add / swap the tier gift and show a popup.
   If the customer removed the gift, the cart shows an "Add it back" reminder and
   the checkout button asks once before leaving without it.
   Prices are handled by Shopify automatic discounts, not here. */
(function () {
  var cfg = window.MDFreeGift;
  if (!cfg || !window.fetch) return;
  if (cfg.startsAt && Date.now() < Date.parse(cfg.startsAt)) return;

  var KEY_ADDED = 'mdGiftAdded';
  var KEY_DISMISSED = 'mdGiftDismissed';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var tiers = cfg.tiers.slice().sort(function (a, b) { return b.min - a.min; });
  var giftIds = tiers.map(function (t) { return t.variantId; });
  var nativeFetch = window.fetch.bind(window);
  var running = false;
  var pending = false;
  var timer = null;
  var waiters = [];
  var lastState = { target: null, missing: false };
  var skipConfirm = false;

  function store(method, key, value) {
    try {
      if (method === 'get') return sessionStorage.getItem(key);
      if (method === 'set') sessionStorage.setItem(key, value);
      if (method === 'del') sessionStorage.removeItem(key);
    } catch (e) {}
    return null;
  }

  function post(path, body) {
    return nativeFetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function sectionIds() {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    return sections;
  }

  function money(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 250);
  }

  // Resolves once no cart check is queued or running.
  function settle() {
    return new Promise(function (resolve) {
      if (!running && !timer) resolve(); else waiters.push(resolve);
    });
  }

  async function refreshCart() {
    var sections = sectionIds();
    var fresh = await (await post('cart/update.js', { updates: {}, sections: sections })).json();
    if (window.theme && theme.pubsub) {
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'md-gift', cart: fresh });
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
  }

  // Put back a gift the customer removed (reminder button / checkout prompt).
  async function addGift(target) {
    var res = await post('cart/add.js', { items: [{ id: target.variantId, quantity: 1 }] });
    if (!res.ok) return null;
    var json = await res.json();
    store('set', KEY_ADDED, String(target.variantId));
    store('del', KEY_DISMISSED);
    lastState = { target: target, missing: false };
    renderReminders();
    await refreshCart();
    return json.items && json.items[0];
  }

  async function reconcile() {
    timer = null;
    if (running) { pending = true; return; }
    running = true;
    try {
      var cart = await (await nativeFetch(root + 'cart.js', { credentials: 'same-origin' })).json();
      var dice = 0;
      var autoLines = [];
      // Gift lines are recognised by their gift variant (no line property, so
      // nothing extra shows on orders or packing slips).
      cart.items.forEach(function (item) {
        if (giftIds.indexOf(item.variant_id) !== -1) {
          autoLines.push(item);
        } else if (cfg.excludeTypes.indexOf(item.product_type) === -1) {
          dice += item.quantity;
        }
      });

      var target = null;
      for (var i = 0; i < tiers.length; i++) {
        if (dice >= tiers[i].min) { target = tiers[i]; break; }
      }

      var targetId = target ? String(target.variantId) : null;
      var hasTarget = target && autoLines.some(function (l) { return l.variant_id === target.variantId; });
      var prevAdded = store('get', KEY_ADDED);

      // The customer removed the gift we added: respect that until the tier changes.
      if (target && !hasTarget && store('get', KEY_ADDED) === targetId) {
        store('set', KEY_DISMISSED, targetId);
      }
      if (!target) {
        store('del', KEY_ADDED);
        store('del', KEY_DISMISSED);
      }

      // Take the free unit off gift lines that no longer match the tier. Extra
      // units the customer added stay on the line as paid items.
      var updates = {};
      var changed = false;
      autoLines.forEach(function (l) {
        if ((!target || l.variant_id !== target.variantId) && (l.quantity === 1 || String(l.variant_id) === prevAdded)) {
          updates[l.key] = l.quantity - 1;
          changed = true;
        }
      });
      if (changed) await post('cart/update.js', { updates: updates });

      var added = null;
      if (target && !hasTarget && store('get', KEY_DISMISSED) !== targetId) {
        var res = await post('cart/add.js', { items: [{ id: target.variantId, quantity: 1 }] });
        if (res.ok) {
          var json = await res.json();
          added = json.items && json.items[0];
          store('set', KEY_ADDED, targetId);
          store('del', KEY_DISMISSED);
          changed = true;
        }
      }

      lastState = { target: target, missing: !!(target && !hasTarget && !added) };
      renderReminders();
      if (changed) await refreshCart();
      if (added) showPopup(added, target);
    } catch (e) {
      console.error('[md-gift]', e);
    } finally {
      running = false;
      if (pending) {
        pending = false;
        schedule();
      } else if (!timer) {
        waiters.splice(0).forEach(function (resolve) { resolve(); });
      }
    }
  }

  function setText(el, text) {
    if (el.textContent !== text) el.textContent = text;
  }

  function giftWorth(target) {
    return target && target.worth ? money(target.worth) : '';
  }

  // Reminder where the gift line would be: right under the item list, in the
  // cart drawer and on the /cart page.
  function reminderAnchors() {
    var anchors = [];
    document.querySelectorAll('cart-items').forEach(function (el) {
      anchors.push({ el: el, after: true });
    });
    return anchors;
  }

  function renderReminders() {
    var s = cfg.strings;
    reminderAnchors().forEach(function (anchor) {
      var form = anchor.el;
      var box = anchor.after ? form.nextElementSibling : form.previousElementSibling;
      if (!box || !box.classList.contains('md-gift-reminder')) box = null;
      if (!lastState.missing) {
        if (box) box.remove();
        return;
      }
      if (!box) {
        box = document.createElement('div');
        box.className = 'md-gift-reminder';
        box.innerHTML = '<p class="md-gift-reminder__text"></p><button type="button" class="md-gift-reminder__btn"></button>';
        box.querySelector('button').addEventListener('click', function () {
          var btn = this;
          if (!lastState.target) return;
          btn.disabled = true;
          addGift(lastState.target).then(function (item) {
            btn.disabled = false;
            if (item) showPopup(item, lastState.target);
          });
        });
        form.parentNode.insertBefore(box, anchor.after ? form.nextSibling : form);
      }
      var worth = giftWorth(lastState.target);
      // Only touch the text when it changes, so the MutationObserver below does not loop.
      setText(box.querySelector('.md-gift-reminder__text'), s.reminder.replace('{worth}', worth ? ' (' + s.worth.toLowerCase() + ' ' + worth + ')' : ''));
      setText(box.querySelector('.md-gift-reminder__btn'), s.reminderButton);
    });
  }

  // Go straight to checkout: the drawer re-renders after adding the gift, so the
  // original checkout form may no longer be in the page.
  function goToCheckout(trigger) {
    skipConfirm = true;
    window.location.href = (trigger && trigger.href) || root + 'checkout';
  }

  function showCheckoutPrompt(trigger) {
    var s = cfg.strings;
    var target = lastState.target;
    var old = document.getElementById('md-gift-popup');
    if (old) old.remove();
    var wrap = document.createElement('div');
    wrap.id = 'md-gift-popup';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.innerHTML =
      '<div class="md-gift-popup__backdrop"></div>' +
      '<div class="md-gift-popup__box">' +
        '<p class="md-gift-popup__title"></p>' +
        '<p class="md-gift-popup__note"></p>' +
        '<button type="button" class="md-gift-popup__btn" data-add></button>' +
        '<button type="button" class="md-gift-popup__skip" data-skip></button>' +
      '</div>';
    var worth = giftWorth(target);
    wrap.querySelector('.md-gift-popup__title').textContent = s.promptTitle;
    wrap.querySelector('.md-gift-popup__note').textContent = s.promptNote.replace('{worth}', worth ? ' ' + s.worth.toLowerCase() + ' ' + worth : '');
    var add = wrap.querySelector('[data-add]');
    var skip = wrap.querySelector('[data-skip]');
    add.textContent = s.promptAdd;
    skip.textContent = s.promptSkip;
    add.addEventListener('click', function () {
      add.disabled = skip.disabled = true;
      addGift(target).then(function () { goToCheckout(trigger); }, function () { goToCheckout(trigger); });
    });
    skip.addEventListener('click', function () { wrap.remove(); goToCheckout(trigger); });
    wrap.querySelector('.md-gift-popup__backdrop').addEventListener('click', function () { wrap.remove(); });
    document.body.appendChild(wrap);
    add.focus();
  }

  // Before leaving for checkout, finish any queued gift check, then ask once if the gift is missing.
  document.addEventListener('click', function (event) {
    if (skipConfirm || event.defaultPrevented || event.button > 0) return;
    var trigger = event.target.closest && event.target.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!trigger || trigger.disabled) return;
    if (!running && !timer && !lastState.missing) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (timer) { clearTimeout(timer); timer = null; reconcile(); }
    settle().then(function () {
      if (lastState.missing) showCheckoutPrompt(trigger); else goToCheckout(trigger);
    });
  }, true);

  function showPopup(item, tier) {
    var s = cfg.strings;
    var old = document.getElementById('md-gift-popup');
    if (old) old.remove();
    var image = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '';
    var wrap = document.createElement('div');
    wrap.id = 'md-gift-popup';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.innerHTML =
      '<div class="md-gift-popup__backdrop"></div>' +
      '<div class="md-gift-popup__box">' +
        '<p class="md-gift-popup__title"></p>' +
        (image ? '<img class="md-gift-popup__img" alt="" width="120" height="120">' : '') +
        '<p class="md-gift-popup__name"></p>' +
        '<p class="md-gift-popup__price"><s></s> <strong></strong></p>' +
        '<p class="md-gift-popup__note"></p>' +
        '<button type="button" class="md-gift-popup__btn"></button>' +
      '</div>';
    wrap.querySelector('.md-gift-popup__title').textContent = s.title;
    if (image) wrap.querySelector('img').src = image;
    wrap.querySelector('.md-gift-popup__name').textContent = item.product_title;
    wrap.querySelector('s').textContent = s.worth + ' ' + money(item.original_price);
    wrap.querySelector('strong').textContent = s.free;
    wrap.querySelector('.md-gift-popup__note').textContent = (tier && tier.min === tiers[0].min && s.noteTop) ? s.noteTop : s.note;
    var btn = wrap.querySelector('.md-gift-popup__btn');
    btn.textContent = s.button;
    function close() { wrap.remove(); }
    btn.addEventListener('click', close);
    wrap.querySelector('.md-gift-popup__backdrop').addEventListener('click', close);
    document.body.appendChild(wrap);
    btn.focus();
  }

  var css = document.createElement('style');
  css.textContent =
    '#md-gift-popup{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px}' +
    '#md-gift-popup .md-gift-popup__backdrop{display:block;position:absolute;inset:0;background:rgba(0,0,0,.6)}' +
    '.md-gift-popup__box{position:relative;background:#fff;color:#111;border-radius:12px;max-width:340px;width:100%;padding:24px 20px;text-align:center;box-shadow:0 10px 30px rgba(0,0,0,.25)}' +
    '.md-gift-popup__title{font-size:20px;font-weight:700;margin:0 0 12px}' +
    '.md-gift-popup__img{display:block;margin:0 auto 10px;width:120px;height:120px;object-fit:contain}' +
    '.md-gift-popup__name{font-size:15px;margin:0 0 6px}' +
    '.md-gift-popup__price{margin:0 0 10px;font-size:15px}.md-gift-popup__price s{color:#888}.md-gift-popup__price strong{color:#c0392b}' +
    '.md-gift-popup__note{font-size:13px;color:#555;margin:0 0 16px}' +
    '.md-gift-popup__btn{width:100%;padding:12px;border:0;border-radius:8px;background:#111;color:#fff;font-size:15px;cursor:pointer}' +
    '.md-gift-popup__skip{display:block;width:100%;margin-top:10px;padding:8px;border:0;background:none;color:#666;font-size:14px;text-decoration:underline;cursor:pointer}' +
    '.md-gift-reminder{display:flex;align-items:center;gap:10px;margin:12px 0;padding:10px 12px;border:1px dashed #c0392b;border-radius:8px;background:#fff5f3;color:#111}' +
    '.md-gift-reminder__text{flex:1;margin:0;font-size:13px;line-height:1.35}' +
    '.md-gift-reminder__btn{flex:none;padding:8px 12px;border:0;border-radius:6px;background:#111;color:#fff;font-size:13px;font-weight:600;cursor:pointer}';
  document.head.appendChild(css);

  // Catch cart changes made by the theme or by apps through fetch.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(schedule, function () {});
    }
    return p;
  };

  // The drawer re-renders its HTML after cart changes; put the reminder back.
  var reminderTimer = null;
  new MutationObserver(function () {
    if (!lastState.missing) return;
    clearTimeout(reminderTimer);
    reminderTimer = setTimeout(renderReminders, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });

  function subscribe() {
    if (window.theme && theme.pubsub) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event || event.source !== 'md-gift') schedule();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { subscribe(); schedule(); });
  } else {
    subscribe();
    schedule();
  }
})();
